import * as React from "react";

function SvgHeading2(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}><path d="M7.7 12.7h-2v-4H2v4H0V3.4h2v3.7h3.7V3.4h2v9.3zM16 12.7H9.4v-1.4L11.8 9c.7-.7 1.1-1.2 1.4-1.5.2-.3.4-.5.5-.8.1-.2.1-.5.1-.7 0-.4-.1-.7-.3-.8-.2-.2-.5-.3-.8-.3-.4 0-.7.1-1 .3-.3.2-.7.4-1.1.7L9.4 4.6c.5-.4.8-.7 1.1-.8.3-.2.6-.3 1-.4.4-.1.8-.1 1.2-.1.6 0 1.1.1 1.6.3.5.2.8.5 1 .9s.4.8.4 1.3c0 .4-.1.8-.2 1.2-.2.4-.4.8-.7 1.2s-.9 1-1.7 1.7L11.9 11v.1H16v1.6z" /></svg>;
}

export default SvgHeading2;